import React from 'react';
import { useLanguage } from '../../App';

const WhyUs = () => {
  const { t } = useLanguage();

  const features = [
    { id: "01", text: t('whyUsPage.feature1'), gradient: "from-[#1A4D90] to-[#2A7DE1]" },
    { id: "02", text: t('whyUsPage.feature2'), gradient: "from-[#2A7DE1] to-[#4facfe]" },
    { id: "03", text: t('whyUsPage.feature3'), gradient: "from-[#1A4D90] to-[#0C2341]" },
    { id: "04", text: t('whyUsPage.feature4'), gradient: "from-[#4facfe] to-[#00f2fe]" },
  ];

  return (
    <section className="w-full bg-[#030B15] py-20 px-6 font-alexandria overflow-hidden">
      <div className="max-w-[1232px] mx-auto flex flex-col items-center">
        
        <h2 className="text-[#1A4D90] font-medium text-[25px] text-center mb-16 w-full"
            style={{ 
                fontFamily: 'Alexandria', 
                fontWeight: 500, 
                lineHeight: '100%',
                letterSpacing: '0%' 
            }}>
          {t('whyUsPage.title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-[1231px]">
          {features.map((item) => (
            <div 
              key={item.id}
              className="group relative p-8 rounded-[20px] bg-[#0A1628] border border-white/5 
                         hover:border-[#1A4D90]/40 transition-all duration-500 flex items-center gap-6 overflow-hidden"
            >
              <div className="relative flex-shrink-0">
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${item.gradient} rotate-45 
                                group-hover:rotate-[135deg] transition-transform duration-700 opacity-20`}></div>
                <div className="absolute inset-0 flex items-center justify-center font-bold text-[#1A4D90] text-xl">
                  {item.id}
                </div>
              </div>

              {/* نص الميزة */}
              <div className="flex-grow">
                <p className="text-[#CFCFCF] font-light text-[20px] md:text-[22px] group-hover:text-white transition-colors duration-300"
                   style={{ 
                       fontFamily: 'Alexandria', 
                       fontWeight: 300, 
                       lineHeight: '32px' 
                   }}>
                  {item.text}
                </p>
              </div>

              <div className={`absolute -right-10 -bottom-10 w-32 h-32 bg-gradient-to-br ${item.gradient} blur-[50px] opacity-0 group-hover:opacity-20 transition-opacity duration-500`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;